import React, { useMemo } from 'react';

// GLOBAL FUNCTIONS
import { Link, useParams, useLocation } from 'react-router-dom';
import { formatDateTime, getPathByStatus, makePath } from 'functions';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';

// HOOKS
import { useLogContext } from '../helpers/logContext';
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// PROTOTYPE
import Log from '../prototype/Log';

// LOCAL PARTS
import ActivityItem from './activityLog/ActivityItem';
import ActivityTable from './activityLog/ActivityTable';

// VARIABLES
const FETCH_ARGS = {
  endpoint: ENDPOINTS.inventory.salesActivity,
  onSuccess: ({ result: { arySalesActivityLog } }) => arySalesActivityLog,
}

// MAIN COMPONENT
const SalesLog = props => {

  // REACT ROUTER
  const { recordID } = useParams();
  const location = useLocation();

  // HOOKS
  const { logs: { [props.name]: { data } = {} } } = useLogContext();
  const { record: { inventory_status_code } = {} } = useRecordContext() || {};

  // MEMOS
  const enableAddSale = useMemo(
    () => !['O', 'S', 'D', 'RET'].includes(inventory_status_code),
    [inventory_status_code]
  )

  // RENDER
  return (
    <Log
      title="Sales Activity"
      fetchArgs={FETCH_ARGS}
      item={({
        customer_full_name, //
        sales_id,
        salesperson_full_name,
        status_css_class_name,
        status_name,
        time
      }) => (
        <ActivityItem title={customer_full_name} timeStamp={formatDateTime(time)}>
          <ActivityTable
            columns={[
              {
                key: 'status_name',
                label: 'Status',
                className: status_css_class_name,
                width: 8
              },
              {
                key: 'salesperson_full_name',
                label: 'Sales Person',
                width: 14
              },
              {
                key: 'sales_id',
                label: '',
                width: 2,
                className: 'text-end',
                as: () => (
                  <Button.Link
                    icon={{
                      use: 'folder',
                      hover: 'folder-open'
                    }}
                    to={{
                      pathname: getPathByStatus(status_name, sales_id),
                      state: { prevPath: location.pathname }
                    }}
                  />
                )
              }
            ]}
            data={[
              {
                salesperson_full_name,
                status_name,
                sales_id
              }
            ]}
          />
        </ActivityItem>
      )}
      emptyMessage="No sales have been entered for this inventory."
      after={(enableAddSale || !data?.length) && <>Click <Link to={makePath(INTERFACE.sales, 'add', recordID)}>here</Link> to add a sale.</>}
      {...props}
    />
  );
};

// EXPORT
SalesLog.Tab = props => <Log.Tab pill={false} icon="delivery-log" {...props} />;
export default SalesLog;
